export const getCollegeId = (college) => college?._id || college?.id || '';

export const getCollegeName = (college) =>
  college?.college_name || college?.name || college?.short_name || college?.shortName || '';

export const getCollegeShortName = (college) =>
  college?.short_name || college?.shortName || '';

export const getCollegeLocation = (college) => {
  const explicitLocation = college?.location;
  const district = college?.district;
  const state = college?.state;

  if (explicitLocation && state && !String(explicitLocation).includes(String(state))) {
    return `${explicitLocation}, ${state}`;
  }

  if (explicitLocation) {
    return explicitLocation;
  }

  if (district && state) {
    return `${district}, ${state}`;
  }

  return district || state || 'Location unavailable';
};

export const getCollegeLogo = (college) =>
  college?.logo_url || college?.logo || '/default-images/Logo/default_logo.png';

export const getCollegeBanner = (college) => {
  const campusImages = Array.isArray(college?.images?.campus) ? college.images.campus : [];
  const firstCampusImage = campusImages.find((image) => image?.secure_url || image?.url);

  if (firstCampusImage) {
    return firstCampusImage.secure_url || firstCampusImage.url;
  }

  if (Array.isArray(college?.images)) {
    const firstImage = college.images.find((image) => image?.secure_url || image?.url);
    if (firstImage) {
      return firstImage.secure_url || firstImage.url;
    }
  }

  return '/default-images/campus/default_campus.png';
};

export const getCollegeSlug = (college) => {
  if (college?.slug) {
    return college.slug;
  }

  const name = getCollegeName(college);
  return name
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
};
